export default __webpack_public_path__ + "static/media/mashup.33291f4b.gif";